import { Container as Container$1 } from "../../../../../player/container.js";
import { jsx } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/shared/components/layout/container.tsx
/** @jsxImportSource react */
function Container({ children, className, ...props }) {
	return /* @__PURE__ */ jsx(Container$1, {
		className: cn("media-skin", "media-container", className),
		...props,
		children
	});
}
//#endregion
export { Container };

//# sourceMappingURL=container.js.map